import type { DocRenderer } from "@cyntler/react-doc-viewer";
import { extractExtension } from "@repo/lib/extractExtension";

export const Unsupported = ({ url }: { url?: string }) => (
  <div className="w-full h-full py-10 text-center">
    <p>File type not supported.</p>
    <p>{url && "*." + extractExtension(url, true)}</p>
  </div>
);

export const UnsupportedRenderer: DocRenderer = ({
  mainState: { currentDocument },
}) => {
  if (!currentDocument) return null;

  return <Unsupported url={currentDocument.uri} />;
};
UnsupportedRenderer.fileTypes = [
  "doc",
  "application/msword",
  "docx",
  "application/vnd.openxmlformats-officedocument.wordprocessingml.document",
  "ppt",
  "application/vnd.ms-powerpoint",
  "pptx",
  "application/vnd.openxmlformats-officedocument.presentationml.presentation",
  "xls",
  "application/vnd.ms-excel",
  "xlsx",
  "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
];
UnsupportedRenderer.weight = 2;
